export const FORMS_FILE_UPLOAD_PATH = '/web3/api/forms/file';
